import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SuperAdminService } from '../../services/super-admin/super-admin.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { SaViewDialogComponent } from './sa-view-dialog/sa-view-dialog.component';
import { SaPermissionDialogComponent } from './sa-permission-dialog/sa-permission-dialog.component';
import { SaViewPairsDialogComponent } from './sa-view-pairs-dialog/sa-view-pairs-dialog.component';

// two sections in one screen: the view hierarchy (with per-view permission
// pairs) and the permission catalogue.
@Component({
  selector: 'app-sa-views',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './sa-views.component.html',
  styleUrls: ['./sa-views.component.scss', '../../../common-style/admin-list-page.scss'],
})
export class SaViewsComponent implements OnInit {
  tab: 'views' | 'permissions' = 'views';
  views: any[] = [];
  permissions: any[] = [];
  isLoading: boolean = false;

  constructor(
    private superAdminService: SuperAdminService,
    private toastService: ToastService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadViews();
    this.loadPermissions();
  }

  setTab(tab: 'views' | 'permissions'): void {
    this.tab = tab;
  }

  loadViews(): void {
    this.isLoading = true;
    this.superAdminService.listViews().subscribe({
      next: (res: any) => {
        this.views = res?.data?.views || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.views = [];
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load views.');
      },
    });
  }

  loadPermissions(): void {
    this.superAdminService.listPermissions().subscribe({
      next: (res: any) => (this.permissions = res?.data?.permissions || []),
      error: (err) => this.toastService.error(err?.error?.message || 'Failed to load permissions.'),
    });
  }

  addView(): void {
    const ref = this.dialog.open(SaViewDialogComponent, {
      width: '760px',
      maxWidth: '95vw',
      data: { views: this.views },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.loadViews();
    });
  }

  editView(view: any): void {
    const ref = this.dialog.open(SaViewDialogComponent, {
      width: '760px',
      maxWidth: '95vw',
      data: { view, views: this.views },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.loadViews();
    });
  }

  managePairs(view: any): void {
    this.dialog.open(SaViewPairsDialogComponent, {
      width: '640px',
      maxWidth: '95vw',
      data: { viewId: view.viewId, viewLabel: view.viewLabel },
    });
  }

  addPermission(): void {
    const ref = this.dialog.open(SaPermissionDialogComponent, { width: '560px', maxWidth: '95vw' });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.loadPermissions();
    });
  }

  editPermission(permission: any): void {
    const ref = this.dialog.open(SaPermissionDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      data: { permission },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.loadPermissions();
    });
  }
}
